import axios from "axios";

export const apiRunWithAxios        =   async (url, method, jwt_token, params, data, headers = {})  => {
    try {
        return await axios({
            url,
            method,
            headers : {
                ...headers,
                'Content-Type'  :   'application/json',
                'Authorization' :   'JWT ' + jwt_token,
            },
            params,
            data
        });
    } catch (error) {
        // const errorMessage = err.response?.data?.message || err.message || 'An error occurred';
        // setError(errorMessage);
        // You can still return data if needed, but it's better to throw
        throw error;
    } finally {
        // setLoading(false);
    }
}